import React, { useEffect, useRef, useState } from "react";
import { ChevronDown, Search } from "lucide-react";

/*
  Searchable dropdown (State / City ke liye).
  onChange ko { target: { name, value } } milta hai,
  isliye existing handleChange seedha kaam karega.
*/
function SearchableSelect({
    name,
    value,
    options,
    onChange,
    placeholder = "Select",
    searchPlaceholder = "Search...",
    icon,
    disabled = false,
}) {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState("");
    const wrapRef = useRef(null);

    // Bahar click par band
    useEffect(() => {
        const handleOutside = (e) => {
            if (wrapRef.current && !wrapRef.current.contains(e.target)) {
                setOpen(false);
                setQuery("");
            }
        };
        document.addEventListener("mousedown", handleOutside);
        return () => document.removeEventListener("mousedown", handleOutside);
    }, []);

    // Disabled hone par band
    useEffect(() => {
        if (disabled) setOpen(false);
    }, [disabled]);

    const filtered = options.filter((option) =>
        option.toLowerCase().includes(query.toLowerCase().trim())
    );

    const choose = (option) => {
        onChange({ target: { name, value: option } });
        setOpen(false);
        setQuery("");
    };

    const handleKeyDown = (e) => {
        if (e.key === "Escape") {
            setOpen(false);
            setQuery("");
        }
        if (e.key === "Enter") {
            e.preventDefault();
            if (filtered.length > 0) choose(filtered[0]);
        }
    };

    return (
        <div
            ref={wrapRef}
            className={`trainer-searchable ${disabled ? "disabled" : ""}`}
        >
            <button
                type="button"
                className={`trainer-searchable-trigger ${open ? "open" : ""}`}
                disabled={disabled}
                onClick={() => setOpen((prev) => !prev)}
            >
                {icon}
                <span className={value ? "" : "placeholder"}>
                    {value || placeholder}
                </span>
                <ChevronDown size={16} className="trainer-searchable-arrow" />
            </button>

            {open && (
                <div className="trainer-searchable-menu">
                    <div className="trainer-searchable-search">
                        <Search size={15} />
                        <input
                            type="text"
                            autoFocus
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            onKeyDown={handleKeyDown}
                            placeholder={searchPlaceholder}
                        />
                    </div>

                    <ul className="trainer-searchable-list">
                        {filtered.length === 0 ? (
                            <li className="trainer-searchable-empty">
                                No results found
                            </li>
                        ) : (
                            filtered.map((option) => (
                                <li
                                    key={option}
                                    className={option === value ? "selected" : ""}
                                    onClick={() => choose(option)}
                                >
                                    {option}
                                </li>
                            ))
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
}

export default SearchableSelect;
